import { gql } from '@apollo/client';

export const MySmartImportsQueryName = 'MySmartImports';

export const MY_SMART_IMPORTS_QUERY = gql`
  query ${MySmartImportsQueryName}($first: Int!, $after: String) {
    mySmartImports(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          createdBy
          importMode
          status
          originalFilename
          rowCount
          progress {
            processedRowCount
            totalRowCount
            currentChunk
            totalChunks
          }
          error {
            code
            message
          }
          createdAt
          updatedAt
          startedAt
          completedAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
